import axios from 'axios';
import { toast } from 'react-toastify';
import { sessionTimeoutManager } from './sessionTimeoutManager';

// Create an axios instance with the base URL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Request interceptor - add token to headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const statusCode = error.response?.status;

    if (statusCode === 401 || statusCode === 403) {
      toast.error('Session expired or access forbidden. Please login again');
      // Show the session timeout modal (let the modal handle clearing storage and redirect)
      sessionTimeoutManager.showSessionTimeout();
    } else if (error.response) {
      toast.error(error.response?.data?.message || 'Response error occurred');
    } else {
      toast.error('Unable to reach the server. Please try again.');
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
